@if (loading()) {
  <app-loading></app-loading>
}

<ng-container *transloco="let t">
  @if (!loading() && data) {
    <div class="container">
      <div class="text-center">
        <h1>{{ t('our_offers') }}</h1>
      </div>

      <p (click)="sidebarVisible = true"
        class="flex justify-content-center align-items-center underline font-semibold cursor-pointer" tabindex="0"
        (keyup.enter)="sidebarVisible = true">{{ t('filter_offers') }}</p>

    </div>
    <div class="container mt-3">
      <div class="grid">
        @for (offer of offers; track offer) {
          <div class="col-12 lg:col-6">
            <app-offer-card [id]="generateOfferUrl(offer)" [title]="offer.titolo | translate" [image]="offer.images?.[0]?.path || offer.foto"
              [expirationDate]="offer.scadenza"></app-offer-card>
          </div>
        }
      </div>
    </div>
  }

  @if (!loading() && data) {
    <p-drawer [(visible)]="sidebarVisible" [showCloseIcon]="false">
      <div class="flex align-items-center justify-content-between">
      <h3>{{ t('filter') }}</h3>
      <a (click)="clearFilters()" class="underline font-semibold cursor-pointer">{{ t('remove-filters') }}</a>
    </div>
    <p class="mb-0">{{ t('filter_text') }}</p>

    <div class="mt-2">
      <p class="font-semibold">{{ t('category') }}:</p>
      <div class="flex align-items-center">
        <p-radioButton name="category" value="all" [(ngModel)]="model['category']" inputId="all"></p-radioButton>
        <label for="ingredient1" class="ml-2">{{ t('categories.all') }}</label>
      </div>

      @if (offersHave('news')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="news" [(ngModel)]="model['category']" inputId="news"></p-radioButton>
            <label for="ingredient2" class="ml-2">{{ t('categories.news') }}</label>
          </div>
          @if (model['category'] == 'news') {
            @for (tag of getTags('news'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }
  
      @if (offersHave('service')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="service" [(ngModel)]="model['category']" inputId="service"></p-radioButton>
            <label for="ingredient3" class="ml-2">{{ t('categories.services') }}</label>
          </div>
          @if (model['category'] == 'service') {
            @for (tag of getTags('service'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }
  
      @if (offersHave('offer')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="offer" [(ngModel)]="model['category']" inputId="offer"></p-radioButton>
            <label for="ingredient4" class="ml-2">{{ t('categories.offers') }}</label>
          </div>
          @if (model['category'] == 'offer') {
            @for (tag of getTags('offer'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }
  
      @if (offersHave('product')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="product" [(ngModel)]="model['category']" inputId="product"></p-radioButton>
            <label for="ingredient4" class="ml-2">{{ t('categories.products') }}</label>
          </div>
          @if (model['category'] == 'product') {
            @for (tag of getTags('product'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }

      @if (offersHave('conventions')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="conventions" [(ngModel)]="model['category']" inputId="product"></p-radioButton>
            <label for="ingredient4" class="ml-2">{{ t('categories.conventions') }}</label>
          </div>
          @if (model['category'] == 'conventions') {
            @for (tag of getTags('conventions'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }
  
      @if (data.events_active && offersHave('event')) {
        <div>
          <div class="flex align-items-center mt-2">
            <p-radioButton name="category" value="event" [(ngModel)]="model['category']" inputId="event"></p-radioButton>
            <label for="ingredient4" class="ml-2">{{ t('categories.events') }}</label>
          </div>
          @if (model['category'] == 'event') {
            @for (tag of getTags('event'); track tag) {
              <div class="flex items-center mt-2 ml-3">
                <p-checkbox [name]="tag.label" [value]="tag.label" [(ngModel)]="model['tags']" />
                <label class="ml-2"> {{ tag.label }} </label>
              </div>
            }
          }
        </div>
      }

      <p class="font-semibold">{{ t('order_by') }}:</p>
      <div class="flex align-items-center">
        <p-radioButton name="orderBy" value="recent" [(ngModel)]="model['orderBy']" inputId="recent"></p-radioButton>
        <label for="ingredient1" class="ml-2">{{ t('order_by_filters.newest') }}</label>
      </div>

      <div class="flex align-items-center mt-2">
        <p-radioButton name="orderBy" value="less_recent" [(ngModel)]="model['orderBy']"
          inputId="less_recent"></p-radioButton>
        <label for="ingredient1" class="ml-2">{{ t('order_by_filters.less_recent') }}</label>
      </div>

      <div class="flex align-items-center mt-2">
        <p-radioButton name="orderBy" value="expiration" [(ngModel)]="model['orderBy']"
          inputId="expiration"></p-radioButton>
        <label for="ingredient1" class="ml-2">{{ t('order_by_filters.expiration') }}</label>
      </div>
    </div>

      <div class="mt-4">
        <p-button [label]="t('apply')" class="mt-2" (click)="applyFilter()"></p-button>
      </div>
    </p-drawer>
  }
</ng-container>